export var apiPath='/v2/type_polygraphs';var actionType='POLYGRAPHS';export var bulkActionType="".concat(actionType,"_BULK");export default actionType;